import React from 'react';
import cn from 'classnames';
import IconWrapper from '@components/ui/Icons';
import styles from './ProductValueProposition.module.scss';
import TagManager from 'react-gtm-module';
import { localePathAbs } from '@utils/url';

interface ProductValuePropProps {
  title: string;
  iconName: string;
  linkUrl: string | null;
  locale: string;
  position: number;
}

const ProductValueProposition = ({
  title,
  iconName,
  linkUrl,
  locale,
  position,
}: ProductValuePropProps) => {
  const trackValuePropCLick = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'user_interaction',
        event_name: 'click_value_props',
        page: {
          page_type: 'PDP',
        },
        interaction: {
          interaction_location: `item${position + 1}`,
          link_url: localePathAbs(locale, linkUrl ?? '/'),
          link_text: title,
        },
      },
    });
  };

  return (
    <div className={styles.valuePropContainer}>
      <div className={styles.iconWithText}>
        <IconWrapper
          icon={iconName}
          classNames={cn(styles.icon, styles.valuePropIcon)}
          height={30}
        />
        {linkUrl ? (
          <a
            className={styles.valuePropLink}
            href={`/${locale}/${linkUrl}`}
            onClick={() => trackValuePropCLick()}
          >
            <p className={styles.valuePropTitle}>{title}</p>
          </a>
        ) : (
          <p className={styles.valuePropTitle}>{title}</p>
        )}
      </div>
    </div>
  );
};

export default ProductValueProposition;
